// jshint strict:false, undef:false, unused:false

function removeFormatting(selector = '[data-cleanup]') {
	const wrappers = document.querySelectorAll(selector);
	if (!wrappers.length) return;
	
	wrappers.forEach(wrapper => {
		// Remove Word-specific tags
		wrapper.querySelectorAll('o\\:p, style, meta, link, [xmlns\\:o], [xmlns\\:w]').forEach(el => el.remove());
		
		// Remove Word conditional comments
		wrapper.innerHTML = wrapper.innerHTML.replace(/<!--\[if.*?<!\[endif\]-->/gs, '');
		
		// Loop through all descendant elements
		wrapper.querySelectorAll('*').forEach(el => {
			// Remove Word-specific classes
			if (el.className && typeof el.className === 'string') {
				el.className = el.className
					.split(' ')
					.filter(cls => !/^mso|Mso/.test(cls))
					.join(' ');
			}
			
			// Preserve only width and height in style attribute
			if (el.hasAttribute('style')) {
				const preserved = {};
				const styles = el.getAttribute('style').split(';');
				styles.forEach(style => {
					const [prop, value] = style.split(':').map(s => s.trim());
					if (prop === 'width' || prop === 'height') {
						preserved[prop] = value;
					}
				});

				if (Object.keys(preserved).length) {
					el.setAttribute('style', Object.entries(preserved).map(([k, v]) => `${k}: ${v}`).join('; '));
				} else {
					el.removeAttribute('style');
				}
			}
			
			// Add "d-none" class if element has no textContent (ignoring whitespace)
			let tagName = el.tagName.toLowerCase();
			
			if (tagName !== 'i' && tagName !== 'hr' && (!el.textContent || !el.textContent.trim())) {
				el.classList.add('d-none');
			}
		});
	});
}

export default removeFormatting;
